import { createClient as createSupabaseClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";
const SUPABASE_STORAGE_KEY = "instant3d-auth";

type GlobalSupabaseScope = typeof globalThis & {
  __instant3dSupabaseClient?: SupabaseClient<Database>;
};

function createBrowserSingleton() {
  return createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      storageKey: SUPABASE_STORAGE_KEY,
    },
  });
}

export function getSupabaseBrowserClient() {
  const globalScope = globalThis as GlobalSupabaseScope;

  if (!globalScope.__instant3dSupabaseClient) {
    globalScope.__instant3dSupabaseClient = createBrowserSingleton();
  }

  return globalScope.__instant3dSupabaseClient;
}

export const supabaseBrowserClient = getSupabaseBrowserClient();

export function createClient() {
  return supabaseBrowserClient;
}
